import { Component, Input, OnInit, inject, input } from '@angular/core';

import { TADirectTypeEnum } from '../../../interfaces';
import { UiHelpersService } from '../../../services/ui-helpers/ui-helpers.service';

@Component({
  selector: 'phoenix-miniature',
  templateUrl: './miniature.component.html',
  styles: [
    `
      :host ::ng-deep em {
        font-family: Roboto, 'Helvetica Neue', sans-serif;
        background-color: rgba(255, 255, 0, 1);
        font-style: normal;
        color: black;
        font-weight: bold;
        padding: 2px;
      }

      .mat-mdc-card-content {
        padding: 0;
      }
    `,
  ],
  standalone: false,
})
export class MiniatureComponent implements OnInit {
  textContent: string | undefined;

  @Input() index!: number;
  @Input() data!: any;
  isSelectedData = input(false);

  directTypeEnum = TADirectTypeEnum;
  number = Number;
  private readonly uiHelper = inject(UiHelpersService);

  ngOnInit(): void {
    if (this.data?.type) {
      switch (this.data.type) {
        case this.directTypeEnum.MESSAGE:
          this.textContent = this.data.message?.text ?? '';
          break;
        case this.directTypeEnum.CLIPBOARD:
          this.textContent = this.data.clipboard?.text ?? '';
          break;
        case this.directTypeEnum.KEYLOG:
          this.textContent = this.data.keylog?.keylog ?? '';
          break;
        case this.directTypeEnum.FILE:
          this.textContent = this.data.file?.text ?? '';
          break;
        case this.directTypeEnum.TA_ACCOUNT:
          this.textContent = this.data.taAccount?.notes ?? '';
          break;
        case this.directTypeEnum.HISTORY:
          this.textContent = this.data.history?.pageTitle ?? '';
          break;
        case this.directTypeEnum.WINDOW_LIST:
          this.textContent = (this.data.windowList?.windows ?? [])
            .slice(0, 5)
            .map((window: { windowTitle?: string; text?: string }) =>
              [window.windowTitle, window.text].filter(Boolean).join(': ')
            )
            .filter((line: string) => !!line)
            .join(', ');
          break;
        default:
          this.textContent = '';
          break;
      }
    }
  }

  truncateText(text?: string) {
    if (!text) return '';
    const truncatedText = text.replace(/\n/g, ' ');
    const maxLength = 650;
    if (truncatedText.length > maxLength) {
      return truncatedText.slice(0, maxLength - 3) + '...';
    }
    return truncatedText;
  }

  imgError() {
    this.textContent = this.uiHelper.placeholderPath;
  }

  get taDirectIcon(): string {
    return this.uiHelper.taDirectIcon(this.data?.type ?? '');
  }

  get isCorrupted(): boolean {
    return this.data?.corrupted === true;
  }
}
